export interface AttendanceProps {
  meetingId: string;
  edusignLocked: boolean;
  edusignCourseId?: string | null;
  isMeetingFinished: boolean;
  refreshMeeting: () => void;
}

export enum MeetingAttendanceStatus {
  FORGOTTEN_SIGNATURE = "forgotten_signature",
  JUSTIFIED_ABSENCE = "justified_absence",
}
